var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoFilled = function SvgInfoFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 16.75C4.454 16.75.75 13.046.75 8.5.75 3.946 4.454.25 9 .25a8.253 8.253 0 0 1 8.25 8.25c0 4.546-3.696 8.25-8.25 8.25M8.927 5.629c.607 0 1.084-.486 1.084-1.1s-.477-1.1-1.084-1.1a1.09 1.09 0 0 0-1.092 1.1c0 .614.486 1.1 1.092 1.1m-1.383 7.554h3.39c.347 0 .614-.25.614-.598a.6.6 0 0 0-.615-.59H9.906V7.763c0-.453-.227-.76-.655-.76H7.68a.597.597 0 0 0-.606.59.59.59 0 0 0 .607.599h.89v3.801H7.543a.6.6 0 0 0-.615.59c0 .348.267.6.615.6"
  })));
};
export default SvgInfoFilled;